module.exports = __webpack_public_path__ + "components/MapControl/svg/Szlak pieszy żółty.svg?a38f13e7";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Szlak pieszy żółty.svg
// module id = 2022
// module chunks = 0